import React from 'react';
import { Descriptions, Spin } from 'antd';
import strings from '../../utils/strings';
import { isEmpty } from 'lodash';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function CompanySaleReportTotal() {
    const reports = useReportsStore()
    const data = reports.businessCompanySaleReport.data;
    const loading = reports.businessCompanySaleReport.loading;


    let totalSaleCount = 0;
    data && data.forEach(element => {
        totalSaleCount += (element.SaleCount);
    });

    let totalAmount = 0;
    data && data.forEach(element => {
        totalAmount += (element.Amount);
    });

    let totalSumPayment = 0;
    data && data.forEach(element => {
        totalSumPayment += (element.SumPayment);
    });


    if (isEmpty(data)) {
        return <div></div>
    }
    return (
        <Spin style={{ marginTop: "10px" }} spinning={loading}>
            <Descriptions bordered size="small">
                <Descriptions.Item label="جمع تعداد فروش">{strings.currencyFormat(totalSaleCount)}</Descriptions.Item>
                <Descriptions.Item label="جمع مبلغ فروش">{strings.currencyFormat(totalAmount)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="جمع مبلغ پرداختی">{strings.currencyFormat(totalSumPayment)}&nbsp;ریال</Descriptions.Item>
            </Descriptions>
        </Spin>
    );
}



